import { useUserData } from 'Foundation/User/UserContext';
import { Mock } from './Mock/Mock';
import { SiteTools } from './SiteTools';
import { UserInfo } from './UserInfo';
import { UserPreferences } from './UserPreferences';
import { EmployeeTools } from './EmployeeTools';
import { Tab, Tabs } from '@lmig/lmds-react-tabs';
import { AgentInfo } from './AdminTiles/AgentInfo';

export function AgentTool() {
  const { userData } = useUserData();
  return (
    <>
      <Tabs compact>
        <Tab labelVisual="Agent Info">
          <div className="admin-tools-row">{!userData?.isAgent() && <div className="col-sm-12 col-md-4"><Mock /></div>}<div className="col-sm-12 col-md-8"><AgentInfo /></div></div>
          <UserInfo />
        </Tab>
        {userData && !userData?.isAgent() && (
          <Tab labelVisual="Employee Tools">
            <EmployeeTools />
          </Tab>
        )}
        {userData && !userData?.isAgent() && (
          <Tab labelVisual="User Preferences">
            <UserPreferences />
          </Tab>
        )}
        {userData && !userData?.isAgent() && (
          <Tab labelVisual="Site Tools">
            <SiteTools />
          </Tab>
        )}
      </Tabs>
    </>
  );
}
